

function formatAgeInMonth(age) {

  let ageInMonths = Math.ceil(age * 12);

  if (ageInMonths === 30) {
    return {
      ageText: '2j6m',
      agesHasDifferentTimeUnit: true
    };
  }

  if (ageInMonths >= 24 && ageInMonths % 12 === 0) {
    return {
      ageText: Number(ageInMonths / 12).toString(),
      ageTimeUnit: 'j'
    };
  }

  let ageTimeUnit = 'm';

  if (ageInMonths === 0){
    ageTimeUnit = '';
  }

  return {
    ageText: ageInMonths,
    ageTimeUnit: ageTimeUnit
  };
}

function getAgeForDifferentTimeUnit(age) {

  if(age.agesHasDifferentTimeUnit) {
    return age.ageText;
  }

  return age.ageText + age.ageTimeUnit;
}

function formatAgeParts(start, end){

  if (start.ageTimeUnit !== undefined && end.ageTimeUnit !== undefined && start.ageTimeUnit === end.ageTimeUnit) {
    return start.ageText + '-' + end.ageText + start.ageTimeUnit;
  }

  if (start.ageTimeUnit !== undefined && end.ageTimeUnit !== undefined && start.ageTimeUnit !== end.ageTimeUnit) {
    return start.ageText + start.ageTimeUnit + '-' + end.ageText + end.ageTimeUnit;
  }

  return getAgeForDifferentTimeUnit(start) + '-' + getAgeForDifferentTimeUnit(end);
}

function getAgeRangeForLowStartAge(startage, endage) {

  let start = formatAgeInMonth(startage);
  let end = formatAgeInMonth(endage);

  return formatAgeParts(start, end);
}

function getIntegerPartOf(decimalNumber) {
  return decimalNumber.toString().split('.')[0];
}

function getDecimalPartOf(decimalNumber) {
  let parts = decimalNumber.toString().split('.');
  return Number('0.' + parts[1]);
}

function isValidAgeRange(value) {
  return Number.isInteger(Number(value)) && Number(value) >= 0 && Number(value) <= 99;
}

function getYearsAndMonthFrom(age) {
  if (isValidAgeRange(age)) {
    return {
      ageText: age,
      ageTimeUnit: 'j'
    };
  }
  return {
    ageText: getIntegerPartOf(age) + 'j' + Math.ceil(getDecimalPartOf(age) * 12) + 'm',
    agesHasDifferentTimeUnit: true
  };
}


function getAgeRange(startage, endage) {

  let end = getYearsAndMonthFrom(endage);

  if (startage === 2.5) {

    if (end.ageTimeUnit !== undefined) {
      return startage + '-' + end.ageText + end.ageTimeUnit;
    }

    return startage + 'j-' + end.ageText;


  } else {

    let start = getYearsAndMonthFrom(startage);

    return formatAgeParts(start, end);
  }
}

export function ageRangeToString(startage, endage) {

  if ((startage === undefined && endage === undefined) || (startage === 0 && endage === 0)) {
    return '';
  }

  if(startage === undefined) {
    startage = 0;
  }

  if(endage === undefined) {
    endage = 0;
  }

  if (startage < 2.5) {
    return getAgeRangeForLowStartAge(startage, endage);
  } else {
    return getAgeRange(startage, endage);
  }
}



// WEBPACK FOOTER //
// ./node_modules/@kathondvla/age-range-manager/index.js